import Switcher from "@components/switcher/Switcher";
import React from "react";
import PrimeEuropeOrderFlowDetails from "./PrimeEuropeOrderFlowDetails";
import PrimeEuropeUserDetails from "./PrimeEuropeUserDetails";
import PrimeLogs from "./PrimeLogs";

interface PrimeDetailsEuropeTabsProps {
  instanceId: string;
  width?: string;
}

const PrimeDetailsEuropeTabs: React.FC<PrimeDetailsEuropeTabsProps> = ({
  instanceId,
}) => {
  const tabs = [
    {
      label: "TRADE",
      component: <PrimeEuropeOrderFlowDetails instanceId={instanceId} />,
    },
    {
      label: "USER",
      component: <PrimeEuropeUserDetails instanceId={instanceId} />,
    },
    {
      label: "LOGS",
      component: (
        <PrimeLogs
          instanceId={instanceId}
          endPoint="/analyticsDashboard/getEURCallbackLogs"
        />
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default PrimeDetailsEuropeTabs;
